/** 解析 CMS 字号，兼容 "32" 与 "32px" */
export function parseHomeSectionFontSize(value) {
  if (value == null || value === '') return ''
  const match = String(value).trim().match(/^([\d.]+)(px|rem|em)?$/i)
  if (!match) return ''
  const size = Number.parseFloat(match[1])
  if (!Number.isFinite(size) || size <= 0) return ''
  return `${size}${match[2] || 'px'}`
}

function styleString(value) {
  return value == null ? '' : String(value).trim()
}

function firstStyleValue(...values) {
  for (const value of values) {
    if (value != null && value !== '') return value
  }
  return ''
}

const DEFAULT_LOCALE = 'zh-CN'

/**
 * 按语言回退解析标题样式：当前语言 localeStyles → 默认语言 localeStyles → 主表字段
 */
export function resolveHomeSectionHeadingFields(section, locale = '') {
  if (!section) {
    return {
      titleColor: '',
      titleFontSize: '',
      summaryColor: '',
      summaryFontSize: '',
      cardsPerRow: '',
      categoryCardsPerRow: ''
    }
  }
  const localeStyles = section.localeStyles && typeof section.localeStyles === 'object'
    ? section.localeStyles
    : {}
  const overlay = locale ? localeStyles[locale] || {} : {}
  const fallback = localeStyles[DEFAULT_LOCALE] || {}
  return {
    titleColor: firstStyleValue(overlay.titleColor, fallback.titleColor, section.titleColor),
    titleFontSize: firstStyleValue(overlay.titleFontSize, fallback.titleFontSize, section.titleFontSize),
    summaryColor: firstStyleValue(overlay.summaryColor, fallback.summaryColor, section.summaryColor),
    summaryFontSize: firstStyleValue(overlay.summaryFontSize, fallback.summaryFontSize, section.summaryFontSize),
    cardsPerRow: firstStyleValue(overlay.cardsPerRow, fallback.cardsPerRow, section.cardsPerRow),
    categoryCardsPerRow: firstStyleValue(
      overlay.categoryCardsPerRow,
      fallback.categoryCardsPerRow,
      section.categoryCardsPerRow
    )
  }
}

/** 根据模块配置生成标题/简介 CSS 变量；未填写时不覆盖默认样式 */
export function buildHomeSectionHeadingStyle(section, locale = '') {
  if (!section) return {}
  const fields = resolveHomeSectionHeadingFields(section, locale)
  const style = {}
  const titleColor = styleString(fields.titleColor)
  const titleSize = parseHomeSectionFontSize(fields.titleFontSize)
  const summaryColor = styleString(fields.summaryColor)
  const summarySize = parseHomeSectionFontSize(fields.summaryFontSize)
  if (titleColor) style['--home-title-color'] = titleColor
  if (titleSize) style['--home-title-size'] = titleSize
  if (summaryColor) style['--home-summary-color'] = summaryColor
  if (summarySize) style['--home-summary-size'] = summarySize
  if (section.summaryFromCms) {
    style['--home-summary-transform'] = 'none'
    style['--home-summary-tracking'] = 'normal'
  }
  return style
}
